import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferencePriceType } from 'domains/references';
import { Flex, Text } from 'UI';
import { textFormatter } from 'utils';

export const PriceDisplay = ({ priceData }: { priceData?: ReferencePriceType }) => {
  const { t } = useTranslation();

  const vatIncluded = textFormatter.formatCurrency(priceData?.garageView?.vatIncludedPrice ?? 0, priceData?.currency);
  const vatExcluded = textFormatter.formatCurrency(priceData?.garageView?.vatExcludedPrice ?? 0, priceData?.currency);

  return (
    <Flex direction="column" maxWidth={200}>
      <Text type="lg" bold disableGutter noWrap>
        {t('common.price.vat_include_price', '{{vat_include_price}} VAT. Incl', {
          vat_include_price: vatIncluded,
        })}
      </Text>
      <Text type="sm" disableGutter noWrap>
        {t('common.price.or_vat_exclude_price', 'or {{vat_exclude_price}} VAT. Excl', {
          vat_exclude_price: vatExcluded,
        })}
      </Text>
    </Flex>
  );
};
